import React from 'react';
import type { FieldConfigurationComponentProps } from '../../../../types.tsx';
import { ApprovalsData } from './main.tsx';

export const ApprovalsFieldConfiguration = (props: FieldConfigurationComponentProps) => (
	<ApprovalsData configuration={props.field.configuration} />
);

/**
 * Approvals field card has some static text inside which we want to be always accessible.
 * ... this also could have been an ActiveFieldHeaderInfo.
 */
export const isExpandable = () => true;
